import { Link } from "react-router-dom";
import { Logo } from "@/components/Logo";
import { scrollToId } from "@/lib/api";

export const Footer = () => (
  <footer className="bg-fango py-16">
    <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-10 px-5 sm:px-8 md:flex-row md:items-center">
      <div>
        <Logo light />
        <p className="mt-4 max-w-xs text-sm leading-relaxed text-linen/80">
          Costruisci un'attività solida, senza diventare prigioniera del tuo lavoro.
        </p>
      </div>
      <div className="flex flex-col gap-3 text-sm text-linen/85">
        <button data-testid="footer-link-metodo" onClick={() => scrollToId("metodo")} className="text-left transition-colors hover:text-linen">Il Metodo</button>
        <button data-testid="footer-link-contenuti" onClick={() => scrollToId("contenuti")} className="text-left transition-colors hover:text-linen">Contenuti</button>
        <button data-testid="footer-link-faq" onClick={() => scrollToId("faq")} className="text-left transition-colors hover:text-linen">Domande frequenti</button>
        <Link to="/area-riservata" data-testid="footer-member-access-link" className="font-semibold text-linen underline decoration-terracotta decoration-2 underline-offset-4 transition-colors hover:text-cream">
          Area riservata →
        </Link>
        <a href="mailto:lamiaprimaoradiliberta@outlook.it" data-testid="footer-support-link" className="text-left text-linen/85 transition-colors hover:text-linen">
          Assistenza: lamiaprimaoradiliberta@outlook.it
        </a>
        <a href="tel:+393896265156" data-testid="footer-phone-link" className="text-left text-linen/85 transition-colors hover:text-linen">
          Telefono: +39 389 626 5156
        </a>
        <a
          href="https://wa.me/393896265156?text=Ciao!%20Vorrei%20informazioni%20su%20La%20Tua%20Prima%20Ora%20di%20Libert%C3%A0"
          target="_blank"
          rel="noopener noreferrer"
          data-testid="footer-whatsapp-link"
          className="font-semibold text-linen underline decoration-terracotta decoration-2 underline-offset-4 transition-colors hover:text-cream"
        >
          Scrivici su WhatsApp →
        </a>
      </div>
    </div>
    <div className="mx-auto mt-12 max-w-7xl border-t border-linen/20 px-5 pt-8 sm:px-8">
      <p className="text-xs text-linen/60">© 2026 Prima Ora di Libertà · Tutti i diritti riservati</p>
    </div>
  </footer>
);
